const CONTROL_CHARACTER = /[\u0000-\u001f\u007f]/;
/**
 * Accept only an origin-relative path. Backslashes are rejected because
 * browsers normalize them as path separators for HTTP(S) URLs, which can turn
 * `/\\host` into a cross-origin target.
 */
export function isSafeAuthReturnTo(value) {
    if (typeof value !== "string" ||
        !value.startsWith("/") ||
        value.startsWith("//") ||
        value.includes("\\") ||
        CONTROL_CHARACTER.test(value)) {
        return false;
    }
    return true;
}
export function safeAuthReturnTo(value) {
    return isSafeAuthReturnTo(value) ? value : "/";
}
//# sourceMappingURL=return-to.js.map